var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Mssg = dynamicRequire('Mssg.jsx');

class Alerts extends React.Component {
    render() {
        return <div className="lr-casefactory-choices-alerts alerts">
            <div className="lr-casefactory-choices-alert alert"
                 style={this.showDoorWarning() ? {display: 'block'} : {display: 'none'}}>
                <span
                    className="lr-casefactory-choices-attention attention"><Mssg __key="nc_casefactory.attention" />: </span><Mssg __key="nc_casefactory.alert.too.big.for.door" />
            </div>

            <div className="lr-casefactory-choices-alert alert"
                 style={this.showHeavyWarning() ? {display: 'block'} : {display: 'none'}}>
                <span
                    className="lr-casefactory-choices-attention attention"><Mssg __key="nc_casefactory.attention" />: </span><Mssg __key="nc_casefactory.alert.too.heavy.to.carry" />
            </div>
        </div>
    }

    showHeavyWarning() {
        return this.props.case.dimensions.interior.width * this.props.case.dimensions.interior.height * this.props.case.dimensions.interior.depth > 200000000;
    }

    showDoorWarning() {
        return this.props.case.dimensions.exterior.width > 800 && this.props.case.dimensions.exterior.depth > 800;
    }
}

Alerts.contextTypes = {
};


module.exports = Alerts;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/Alerts.jsx